import { FeaturedPostSlider } from '../../../js/src/__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		FeaturedPostSlider.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
